import * as React from 'react';
import { pluralize } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';
import { ToggleButton as ToggleButtonComponent } from '../../components/Promos/ToggleButton';
import { QUANTITY_PROMOS_IN_ROW } from '../../constants/promos';
import { getPromoCount } from '../../selectors/newbuilding';

interface IToggleButtonProps {
  opened: boolean;
  onClick(): void;
}

export const ToggleButton = (props: IToggleButtonProps) => {
  const count = useSelector(getPromoCount);

  return (
    <ToggleButtonComponent
      {...props}
      closedText={`Показать еще ${pluralize(count - QUANTITY_PROMOS_IN_ROW, ['акцию', 'акции', 'акций'])}`}
    />
  );
};
